import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PaginationModel, PatRxHistoryInputParams, SystemData } from 'src/app/models';
import { AlertService, CommonService, ErxService, PatPreDrugModalService, RxService, RxTransferService } from 'src/app/services';
import { StorageService } from 'src/app/services/storage.service';
import { ColorCode, CommonUtil, PatchRXFGUtil, WijimoUtil } from 'src/app/utils';
import { CollectionView } from "@grapecity/wijmo";
import { FormatsUtil } from 'src/app/utils/formats.util';
import { IntegerFloatPipe } from 'src/app/pipes/integer-float-format.pipe';
import * as wjcGrid from "@grapecity/wijmo.grid"
import { ColorCodeRx } from 'src/app/utils/rx-color.util';
import { PatientInfoUtil } from 'src/app/utils/patient-info.util';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup } from '@angular/forms';
import { RxStore } from "src/app/store";
import { DrugMissingFormComponent } from '../drug-missing-form/drug-missing-form.component';
import { MsgConfig } from "src/app/app.messages";
import { CommonWarnorconfirmPopupComponent } from '../common-warnorconfirm-popup/common-warnorconfirm-popup.component';
@Component({
  selector: 'app-tranferable-information-rxs',
  templateUrl: './tranferable-information-rxs.component.html',
  styleUrls: ['./tranferable-information-rxs.component.scss']
})
export class TranferableInformationRxsComponent implements OnInit {
 isInitialized: boolean = false;
  wjHeaders: any;
  transferModes = [
    { id: 1, name: 'Fax', icon: 'fa-light fa-fax', class: 'fax-option' },
    { id: 2, name: 'Electronic', icon: 'fa-light fa-file-prescription', class: 'electronic-option' },
    { id: 3, name: 'Informational Rx', icon: 'fa-light fa-file-prescription', class: 'informational-option' }
  ];
   unsubscribe$ : Subject<void> = new Subject();
   @Input() RequestedInfo: any;
   @Input() IsfrmPatHis: boolean;
   @Input() currentDetails: any;
   @Input() IsFullscreenMode: any;
   @Input() IsFromProcess: boolean;
   @Input() IsTransferType: string;
   @Input() eRxModelFG: FormGroup;
   @Input() PatientNotFound: number;
   @Input() IsPush: boolean;
   @Input() IsFromXfroutInfo: boolean;
   notTransferInRxs: any = [];
   transferInRxsDisplay: any = [];
   transferInRxs: any = [];
   selectedeRxRecords: any = [];
   @Output() emitRxSelection = new EventEmitter();
   @Output() emitPatientSelection = new EventEmitter();
   @Output() showFullscreenMode = new EventEmitter();
   totalCount: number;
   transferrableWJ: any;
   nonTransferrableWJ: any;
   isDataExists1 = false;
   warningMessageForTrans: any = [];
   warningMsgforTransfer: string = "";
   isDataExists2 = true;
   rxList: any = [];
   isOriginalRequest = false;
   paginationModel: PaginationModel = new PaginationModel();
   pageNumber = this.paginationModel.pageNumber;
   pageSize = this.paginationModel.pageSize;
  systemData: SystemData;
  rxOriginList: any = [];
   integerFloatFormat = new IntegerFloatPipe();
   selectedItemList: any = [];
   awaitInfo: any;
   IseRxTRxREQ: boolean = false;
   modelRef: any;
   eRxDrugMissingModel: any;
   IsFromPushRecords: any = [];
    transferRefillList: any = [];
    statusName: string;
    transferRefillDifferList: any = [];
    transferRefillUnbilledList: any = [];
    reverseRefillList: any[];
   @Input()
  set SelectedRxList(list : any) {
    if(list?.length)
    {
        this.selectedItemList = [...list];
        if (this.rxList?.TransferableRx?.length || this.rxList.NonTransferableRx?.length) {
            this.isDataExists1 = true;
            this.generatingWJCols(this.rxList.TransferableRx.concat((this.rxList.NonTransferableRx?.length) ? this.rxList.NonTransferableRx : []));
        }
    }
  }
   @Input()
  set SelectedPatientErx(list : any) {
    if(list?.TransferableRx?.length || list?.NonTransferableRx?.length)
    {
        this.rxList = list;
        if (this.rxList?.TransferableRx?.length || this.rxList.NonTransferableRx?.length)
        {
                this.isDataExists1 = true;
                this.generatingWJCols(this.rxList.TransferableRx.concat((this.rxList.NonTransferableRx?.length) ? this.rxList.NonTransferableRx : []), true);
        }
    }
  }

  @Input()
  set PatientInfo(patient : any) {
      this.getPatientInf(patient)
  }

   @Input()
  set DrugItem(drug : any) {
      this.getPatientInf(drug)
  }

    @Input() set IsClearPatient(clearPatient : any) {
        if(clearPatient)
         {
            this.isDataExists1 = false;
            this.transferrableWJ = new CollectionView(null);
            this.rxList = {};
         }
     }


   @Input()
    set TransferRxList(list: any) {
        if(list?.length)
        {
            this.getRxsForTransferInReq(list[0].Patient,null, list.map((item) => {
                return {
                prescNum : item?.Prescription?.PrescNum,
                prescRefillId: item?.PrescReFill.Id
            }
            } ));
        }
    }

    @Input()
    set ListViewforPush(data: any) {
         if(data)
            this.IsFromPushRecords = data;        
    }
    
    @Input()
    set SelectedRecords(data: any) {
        if (data)
        {
            this.selectedeRxRecords = data;
            this.getSelectedRecords(data);
        }
    } 
    payload: any;

     @ViewChild("ConfirmMesgBeforeTransferOut", { static: true})
        ConfirmMesgBeforeTransferOut: any;
    
 modalRef: NgbModalRef;
 PopupHeader: string = "";
 transfData: any;
 notuprxsresponse: any;
 isPickup: any = {
    messages: '', IsConfirm: false,
    IsWarn: false,
    RxRefillTransferOut: false,
    ManualReversal: false,
    TransferNext: false,
    IsOk: false
 };
  constructor(private _wijimoUtils: WijimoUtil,
    public _storageService: StorageService,
    private _commonSer: CommonService,
            private _comnUtil: CommonUtil,
            private _formatsUtil: FormatsUtil,
            private _colorCode: ColorCode,
            private _alertServ: AlertService,
            private _colorCodeRx: ColorCodeRx,
            private _modalService: NgbModal,
            private _patientUtil: PatientInfoUtil,
            private _eRxService:ErxService,
            private _pRxFGUtls: PatchRXFGUtil,
            private _rxStore : RxStore,  
            private _rxService : RxTransferService,        
            private _patPreDrugService: PatPreDrugModalService
        ) {
                this._commonSer.systemData$
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(resp => {
                    if (resp) {
                        this.systemData = resp;
                    }
                });
               }

  ngOnInit(): void {
    this.isPickup.RxRefillTransferOut = this._commonSer.getSetttingValue("PharmacySettings", "ALLOW_REFILL_TRANS_OUT") === "1" ? true : false;
       this.isInitialized =  true;
    this._storageService.setSessionStorage("fromPaGrid", true);
    if(!this.IsPush && !this.IsFromXfroutInfo) {
        if(this.IsFromPushRecords?.length) {
        this.generatingWJCols(this.IsFromPushRecords);
        } else if((this.IsFromProcess || this.IsFullscreenMode || this.IsTransferType || this.eRxModelFG?.value?.patientInfo))  // when Transfer In request process
            this.getRxsForTransferInReq(this.eRxModelFG?.value?.patientInfo ? this.eRxModelFG?.value?.patientInfo : '');
        else {   // When click on message type to show the details
            if(this.rxList.TransferableRx?.length || this.rxList.NonTransferableRx?.length)
            this.generatingWJCols(this.rxList.TransferableRx.concat((this.rxList.NonTransferableRx?.length) ? this.rxList.NonTransferableRx : []));
        }
    }
    this.patchDefaultValHeaders();
            this._wijimoUtils.wjSavedData$.pipe(takeUntil(this.unsubscribe$)).subscribe(w => {
                if (w && w["WijmoKey"] && w["WijmoKey"] === "RxsTransferIn") {
                    this.patchDefaultValHeaders();
                }
            });
    this._rxStore.newrxTransfrIn$.subscribe(val => {
        if(val) {
            if(this.rxList?.TransferableRx?.length) {
                if(val?.ESRxViewModel) {
                const index = this.rxList?.TransferableRx.findIndex((item: any) => { return item.erxViewModel?.erxDetailsInRx?.erxOperationId === val.ESRxViewModel?.erxDetailsInRx?.erxOperationId });
                if (index !== -1) {
                    this.rxList.TransferableRx[index].erxViewModel = val.ESRxViewModel;
                    if(!this.currentDetails?.PatientFound) {
                        val.ESRxViewModel.Patient["PatientFoundMsg"] = "The selected patient was not found in the database and has been added automatically.";
                        this.emitPatientSelection.emit(val?.ESRxViewModel?.Patient);
                    }
                    this.rxList.TransferableRx[index].eRxListingViewModel = null;
                    this.rxList.TransferableRx[index].IsNotProcessedErx = false;
                    this.rxList.TransferableRx[index]['index'] = index;
                    this.rxList.TransferableRx[index]['IsSelected'] = true;
                    if (this.rxList?.TransferableRx?.length || this.rxList.NonTransferableRx?.length) {
                        const index2 = this.selectedItemList.findIndex((eRx: any) => { return eRx?.erxDetailsInRx?.erxOperationId === val.ESRxViewModel?.erxDetailsInRx?.erxOperationId });
                        if(index2 !== -1) {
                            let esRxViewModel:any;
                            esRxViewModel = val.ESRxViewModel;
                            esRxViewModel["IsElectronic"] = this.selectedItemList[index2]["IsElectronic"];
                            esRxViewModel["checkTransfer"] = this.selectedItemList[index2]["IsElectronic"];
                            let isElectronic = this.selectedItemList[index2]["IsElectronic"];
                            this.selectedItemList[index2] = esRxViewModel;
                            this.selectedItemList[index2]["eRxListingViewModel"] = null;
                            this.selectedItemList[index2]["IsNotProcessedErx"] = false;
                            this.rxList.TransferableRx[index]['IsElectronic'] = isElectronic;
                            if(this.selectedItemList[index2]?.Drug?.id) {
                                this.checkDrugValidation(this.rxList.TransferableRx[index],this.selectedItemList[index2],index2,'eRxProccess')
                            }
                            this._rxStore.storeNewRxTransfrInInfo(null);
                        }
                    }
                }
            } else {
                const index = this.rxList?.TransferableRx.findIndex((item: any) => { return item.erxViewModel?.erxDetailsInRx?.erxOperationId === val?.ErxOperationId });
                if (index !== -1) {
                    this.rxList.TransferableRx[index]['IsSelected'] = false;
                    if (this.rxList?.TransferableRx?.length || this.rxList.NonTransferableRx?.length) {
                        const index2 = this.selectedItemList.findIndex((eRx: any) => { return eRx?.erxDetailsInRx?.erxOperationId === val?.ErxOperationId });
                        if(index2 !== -1) {
                            this.selectedItemList.splice(index2,1);
                            this.emitRxSelection.emit(this.selectedItemList);
                            if((this.rxList.TransferableRx?.length || this.rxList.NonTransferableRx?.length)) this.generatingWJCols(this.rxList.TransferableRx.concat((this.rxList.NonTransferableRx?.length) ? this.rxList.NonTransferableRx : []));
                            this._rxStore.storeNewRxTransfrInInfo(null);
                            return this.rxList.TransferableRx[index].IsSelected = false;
                        }
                    }
                }
            }
            }
        }
    });
   }

   getPatientInf(patientInfo) {
   }
   ngOnChanges(changes: SimpleChanges) {
      const isMultimatch = this.isPatientInfoMultiMatch(changes);
    const isPatientInfo = this.isPatientInfoChanged(changes); 
        const eRxOpIds = this.selectedeRxRecords?.map((item: any) => {return item?.ErxOperationId});
        if(!changes?.PatientInfo?.firstChange && this.selectedeRxRecords?.length && this.eRxModelFG?.value?.patientInfo && this.IsPush && this.PatientNotFound > 1 && isMultimatch) {
             this.getRxsForTransferInReq(this.eRxModelFG?.value?.patientInfo, null, null, this.PatientNotFound > 1 ? eRxOpIds : null);
             this.selectedeRxRecords = [];
        } else if(!changes?.PatientInfo?.firstChange && (this.currentDetails || (changes?.SelectedRecords?.currentValue?.length)) && (isPatientInfo || ((this.PatientNotFound > 1 && !(changes?.SelectedRecords?.currentValue?.length) && ((changes?.PatientInfo?.previousValue && changes?.PatientInfo?.currentValue) || (!changes?.PatientInfo?.previousValue && changes?.PatientInfo?.currentValue)) ) ))  && !this.IsFromXfroutInfo && !this.IsFullscreenMode) {
           this.getRxsForTransferInReq(this.eRxModelFG?.value?.patientInfo, null, null, this.PatientNotFound > 1 ? eRxOpIds : null);
            this.selectedeRxRecords = [];
       } else if(this.eRxModelFG?.value?.drugItem && this.eRxModelFG?.value?.drugItem !== 'All' && !this.IsPush && !this.IsFromXfroutInfo && !this.IsFullscreenMode) {
       this.getRxsForTransferInReq(this.eRxModelFG?.value?.patientInfo, this.eRxModelFG?.value?.drugItem);
       }
   } 

   isPatientInfoMultiMatch(changes) {
        return  changes?.PatientInfo && changes?.PatientInfo?.previousValue && (changes?.PatientInfo?.currentValue?.firstname?.trim()?.toUpperCase() === changes?.PatientInfo?.previousValue?.firstname?.trim()?.toUpperCase()) && (changes?.PatientInfo?.currentValue?.lastname?.trim()?.toUpperCase() === changes?.PatientInfo?.previousValue?.lastname?.trim()?.toUpperCase());
   }

     isPatientInfoChanged(changes) {
        return !(changes?.SelectedRecords?.currentValue?.length) && changes?.PatientInfo && ((changes?.PatientInfo?.previousValue && changes?.PatientInfo?.currentValue) || (!changes?.PatientInfo?.previousValue && changes?.PatientInfo?.currentValue))  && ((changes?.PatientInfo?.currentValue?.firstname?.trim()?.toUpperCase() !== changes?.PatientInfo?.previousValue?.firstname?.trim()?.toUpperCase()) || (changes?.PatientInfo?.currentValue?.lastname?.trim()?.toUpperCase() !== changes?.PatientInfo?.previousValue?.lastname?.trim()?.toUpperCase()));
   }
 
   ngOnDestroy() {
        this.isInitialized = false;
        sessionStorage.removeItem("fromPaGrid");
   }
   
   getSelectedRecords(SelectedRecords) {
     //Push
     const listViewforPush: any = [];
    if(SelectedRecords?.length) 
    {
        SelectedRecords.map((item: any) => {
          if( (item["TypeofRx"] === 3 || !item["TypeofRx"])  && (item["Message Type"] === "REFRES" ||
                item["Message Type"] === "NewRx" ||
                item["Message Type"] === "New Rx" ||
                item["Message Type"] === "RxChangeResponse" ||
                item["Message Type"] === "CancelRx") && (item.Status === "Ready To Process" || item.Status === "ReadyToProcess")) {
                        item =  item.totalItem;
                        const pName = item.PatientName.split(", ");
                        listViewforPush.push({
                            ErxOperationId : item.ErxOperationId,
                            patientid : item.PatientId,
                            firstname : pName[0],
                            lastname : pName[1],
                            dob: item.PatientDOB || null
                        });
                } else if(item["TypeofRx"] !== 3) {
                    item = item?.totalItem || item;
                    const pName = item?.PatientName.split(", ");
                    listViewforPush.push({
                        PrescrefillId : item?.PrescrefillId,
                        PrescNum: item['PrescNum'],
                          patientid : item?.PatientId,
                            firstname : pName[0],
                            lastname : pName[1],
                    });
                }
        });
          const prescrefillIds = listViewforPush?.some(item => item?.PrescNum) 
            ? listViewforPush.map(item => item?.PrescNum)
            : null;
        const erxOperationIds = listViewforPush?.some(item => item?.ErxOperationId) 
            ? listViewforPush.map(item => item?.ErxOperationId) 
            : null;
        if((SelectedRecords?.length && SelectedRecords[0]['PatientFound'] > 1))  
            return;
        else if(listViewforPush?.length)
        {
            this.getRxsForTransferInReq({
            firstname : listViewforPush[0].firstname,
            lastname: listViewforPush[0].lastname,
            patientid: listViewforPush[0].patientid,
            dob: listViewforPush[0].dob
        } , null, prescrefillIds, erxOperationIds);
        }
    }
   }
   
   

  async patchDefaultValHeaders() {
    const storedWJ = await this._wijimoUtils.getWJSavedData("RxsTransferIn");
    let headers = this._wijimoUtils.patchDefHeader("RxsTransferIn", storedWJ);
    //removing Refill# to be Transferred except in transfer out info
    if (!this.IsFromXfroutInfo) {
        headers = headers.filter(h => h.hName !== "Refill# to be Transferred");
    }
    this.wjHeaders = headers;
  }
    getRxsForTransferInReq(patient?, drug?, prescNums: any = [], erxOperationIdList: any = null) {
        if(patient)
        {
            this.payload = new PatRxHistoryInputParams();
            const selectedDruginformation = this.RequestedInfo?.Drug?.result[0];
            this.payload.patientId = patient ? patient.patientid : this.RequestedInfo?.Patient?.patientid;
            this.payload.patientFirstName = patient ? patient.firstname : this.RequestedInfo?.Patient?.firstname;
            this.payload.patientLastName = patient ? patient.lastname :  this.RequestedInfo?.Patient?.lastname;
            this.payload.DOB = patient ? patient.dob :  this.RequestedInfo?.Patient?.dob;
            this.payload.drug = drug ?  drug.ndc : selectedDruginformation?.ndc;
            this.payload.prescNums = prescNums?.length ? [...new Set(prescNums)] : [];
            this.payload.PageNumber = 0;
            this.payload.PageSize = this.paginationModel.pageSize;
            this.payload.erxOperationIdList = erxOperationIdList;
             this.payload.RefillorRx = this._commonSer.getSetttingValue("PharmacySettings", "ALLOW_REFILL_TRANS_OUT") === "1" ? true : false;
        }
        this._eRxService.getRxsForTransferInReq(this.payload).pipe(takeUntil(this.unsubscribe$)).subscribe((resp: any) => {
            if (resp.TransferableRx?.length || resp.NonTransferableRx?.length) {
                this.rxList = resp;
                this.isDataExists1 = true;
                this.generatingWJCols(resp.TransferableRx.concat((resp.NonTransferableRx?.length) ? resp.NonTransferableRx : []));
            } else {
                this.transferrableWJ = new CollectionView(null);
                this.rxList = {};
                this.isDataExists1 = false;
            }
        });
    }

    reloadGridDataOnPharmacyChange() { 
        this.generatingWJCols(this.rxList?.TransferableRx?.concat((this.rxList?.NonTransferableRx?.length) ? this.rxList?.NonTransferableRx : []), false, true);
    }
    
    generatingWJCols(rxItemHist, IsfromInfo: boolean = false, isFromPharmacyChange: boolean = false) {
        const mapDataSet=[];
        rxItemHist?.map((item, i) => {
        const k = {};
        const rxItem = item.erxViewModel ? item.erxViewModel : item;
        rxItem['eRxListingViewModel'] = item?.eRxListingViewModel ? item?.eRxListingViewModel : null;        
        rxItem["isNotProcessedErx"] = item?.IsNotProcessedErx;
        rxItem["index"] = i;
        const qtyModel = item?.qtyModel;        
        const selectCheckItem = this.selectedItemList?.find((checkItem: any) => (checkItem?.Prescription?.PrescNum === rxItem?.Prescription?.PrescNum))
        k["RowId"] = ((this.pageNumber - 1) * this.pageSize) + i;
        k["Rx#"] = rxItem?.Prescription?.PrescNum;
        k["IsSelected"] = selectCheckItem  ? true : false;
        rxItem["IsTransfferable"] = (item?.isTranserable) ? true : false;
        k["totalObj"] = item;
        k["IsSpecificNDCAMatchedRecord"] = item.IsSpecificNDCAMatchedRecord;
        k["index"] = i;
        k["Auth#"] = rxItem?.Prescription?.ReFillNum;
        k["Ref"] = k["Ref#"] = rxItem?.PrescReFill?.ReFillNum;
        k["Fill#"] = this._commonSer.checkIsPartialFill(rxItem.PrescReFill, rxItem.Prescription)
        ? rxItem.PrescReFill.PartialFillNo : "";
        k["NDC"] = (rxItem && rxItem.Drug && rxItem.Drug?.ndc) ? this._formatsUtil.getNDCFormat(rxItem.Drug?.ndc): "";
        k["eRx Recvd DateTm"] = rxItem?.eRxListingViewModel?.FileDtTm ? moment.utc(rxItem.eRxListingViewModel?.FileDtTm).local().format(MsgConfig.DATE_FORMAT_TIME_SHORT_YEAR) : null;
        k["Insurance"] = this._commonSer.rxInsurance(rxItem);
        const dispQty = this._formatsUtil.threeFixed(rxItem?.PrescReFill?.DispQty)
        const ordQty = this._formatsUtil.threeFixed(rxItem?.PrescReFill?.OrdQty)
        k["Disp Qty / Ord Qty"] = dispQty + " / " + ordQty;
        k["Status"] =this._comnUtil.getRxStatusinSignleCharacter(rxItem);
        k["Drug Name"] =this._formatsUtil.displaytallmanlettering(rxItem?.Drug);
        k["DrugClass"] = rxItem['eRxListingViewModel']?.DrugClass ? rxItem['eRxListingViewModel']?.DrugClass : rxItem?.Drug?.drugclass;
        k["IsPicked"] = rxItem.pickupRx ? rxItem?.pickupRx?.IsPickedUp === true ? true : false : false;
        k["IsPartiallyPickedup"] = rxItem.pickupRx ? rxItem.pickupRx.IsPartialPickup : false;
        k["Days Supply"] = Math.round(rxItem.PrescReFill?.SupplyDays);
        k["Sig"] = rxItem.SigCodes && rxItem.SigCodes.Description ? rxItem.SigCodes.Description.toUpperCase() : "";
        k["Fill DateTm"] = rxItem?.PrescReFill?.FillDtTm && rxItem?.PrescReFill?.FillDtTm != "0001-01-01T00:00:00" ? moment.utc(rxItem.PrescReFill.FillDtTm).local().format(
            "MM/DD/YYYY hh:mm:ss a") : null;
        k["Refills Left"] = qtyModel?.RefillLeft ? qtyModel?.RefillLeft : 0;
        k["Patient Name"] =
        (rxItem.Patient?.lastname &&  rxItem.Patient?.firstname) ?  (rxItem.Patient?.lastname + ", " + rxItem.Patient?.firstname).toUpperCase() : '';
        const originN = this.systemData.RxOrigin.find(v => v["Id"] === rxItem?.PrescReFill?.RxOriginId);
        k["Rx Origin"] = !(item?.isTranserable) && originN ? originN["Name"] : "Informational Rx";
        if(!IsfromInfo) {
            k["IsElectronic"] = this.determineIsElectronic(selectCheckItem, item, rxItem);
            k["IsFaxDisabled"] = (k["IsElectronic"] === 1 ||  k["IsElectronic"] === 3 || !this.eRxModelFG?.value['IsServiceAvailablity']) ? true : false;
        } else {
            k["IsElectronic"] = (item?.isElectronic) ? 2 : (!item?.isTranserable ? 3: 1);
            k["IsFaxDisabled"] = true;
        }
        if(((rxItem?.Drug?.drugtypeid === 2) || ([2,3,4,5].includes(rxItem?.Drug?.drugclass) && !(Number.isInteger(qtyModel?.RefillLeft)))) && item?.isTranserable) {
            // Compound Drug or Control Partial Fills
            k["IsElectronic"] = 1;
            k["IsFaxDisabled"] = true;
        }
        // This check is needed for pharmacy if service is not available and so added after all above conditions
        if(!IsfromInfo && this.eRxModelFG?.value['targetPharmacy'] && this.eRxModelFG?.value['targetPharmacy']['ServiceLevel'] === false) {
            k["IsFaxDisabled"] = true;
            k["IsElectronic"] = 1;
        }
        if(isFromPharmacyChange) {
            rxItem.IsElectronic = k["IsElectronic"] === 1 ? false : rxItem.IsElectronic;
        } else {
            rxItem.IsElectronic = k["IsElectronic"] === 1 ? false : true;
        }
        rxItem.TotalRemainingQty = qtyModel?.RemainingQty;
        k["totalItem"] = rxItem;
        k["frmErx"] = this.payload?.erxOperationIdList?.length ? true : false;
        k["Sig"] = rxItem.SigCodes ? rxItem.SigCodes.SigCode : "";
        k["IsBilled"] = this._comnUtil.checkIsGreenBilled(rxItem, this.systemData);
        k["Prescriber Name"] = rxItem.Prescriber ? (
          rxItem.Prescriber?.prescriberlastname + ", " + rxItem.Prescriber?.prescriberfirstname).toUpperCase() : null;
        k["License#"] = k["License#"] = rxItem.Prescriber?.prescriberlicensenumber ? rxItem.Prescriber?.prescriberlicensenumber : "";
        k["DEA#"] = rxItem.Prescriber?.prescriberdeanum ? this._formatsUtil.getDeaFormat(rxItem.Prescriber?.prescriberdeanum) : "";
        k["NPI#"] = rxItem.Prescriber?.prescribernpinum ? this._formatsUtil.getDeaFormat(rxItem.Prescriber?.prescribernpinum) : "";
        k['PrescriberInfo'] = rxItem?.Prescriber?.PrescriberAddresses?.find((item: any) => item.Id === rxItem?.Prescriber?.primeAddressId);
        k["PrescriberAddress"] = this._patientUtil.getPatientAddress({
            address1: rxItem.Prescriber?.prescriberaddress1,
            address2: rxItem.Prescriber?.prescriberaddress2,
            city: rxItem.Prescriber?.prescribercity,
            state: rxItem.Prescriber?.prescriberstate,
            zipcode: rxItem.Prescriber?.prescriberzipcode,

        });
        k["T.Rx Qty Rem"] = this._formatsUtil.threeFixed(qtyModel?.RemainingQty);
        k["Qty Being Transferred"] = this._formatsUtil.threeFixed(item?.QtyTransferred);
        k["Refill# to be Transferred"] = (item?.RefillsList);
        if(!IsfromInfo && this.eRxModelFG?.value['targetPharmacy'] && this.eRxModelFG?.value['targetPharmacy']['ServiceLevel'] === false && k["T.Rx Qty Rem"] <= 0) {
            k["IsSelected"] = false;
            const selectCheckItem = this.selectedItemList?.find(
            (checkItem: any) => checkItem?.Prescription?.PrescNum === rxItem?.Prescription?.PrescNum);
            k["IsFaxDisabled"] = true;
            k["IsElectronic"] = 3;
            if (selectCheckItem) {
                this.selectedItemList = this.selectedItemList.filter(
                (item: any) => item?.Prescription?.PrescNum !== selectCheckItem?.Prescription?.PrescNum);
            }
        }
        mapDataSet.push(k); 
        });
        this.transferrableWJ   = new CollectionView(mapDataSet, {
            sortComparer: (a: any, b: any) => {
                return moment(a).isValid() && moment(b).isValid() && (typeof(a) == 'string') && (typeof(b) == 'string') 
                    ? moment(a).diff(moment(b))
                    : null;
            }
        });
        return mapDataSet;
    }
    toggleColorLegend() {
      this._alertServ.showHelpText({ RxStatus: true, DrugName: true, Status: true , IseRxTransfer: true});
  }
  determineIsElectronic(selectCheckItem, item, rxItem) {
       return selectCheckItem && (this.eRxModelFG?.value['targetPharmacy'] && this.eRxModelFG?.value['targetPharmacy']['ServiceLevel'] === false) ? selectCheckItem ?.checkTransfer : (!this.eRxModelFG?.value['IsServiceAvailablity'] ? 1 : !(item?.isTranserable) ? 3 : ((this.eRxModelFG?.value['IsServiceAvailablity'] && rxItem.erxDetailsInRx && (rxItem.erxDetailsInRx.erxOperationId || rxItem.erxDetailsInRx.erxId)) || (rxItem?.Drug.drugclass === 0 || rxItem?.Drug.drugclass === 1)) ? 2 : 1);    
  }

    selectedItems(checkedVal) {
        if(!checkedVal.IsSelected) { // selected Item
            checkedVal.totalItem['checkTransfer'] = checkedVal.IsElectronic;
            checkedVal.totalItem.IsElectronic = checkedVal.IsElectronic;
            this.selectedItemList.push(checkedVal.totalItem);
        } else {
            const index = this.selectedItemList.findIndex((item: any) => { return item.index === checkedVal.index; });
            this.selectedItemList.splice(index,1);
        }
        let erxItem = this.selectedItemList.find((item: any) => { return item.isNotProcessedErx === true; });
        this.selectedItemList?.forEach(item => {
            if(item?.eRxListingViewModel)
                  item.eRxListingViewModel.PatientId = this.eRxModelFG?.value?.patientID;
        });        
        if(erxItem && erxItem?.eRxListingViewModel) {            
            this.emitRxSelection.emit(this.selectedItemList);
        } else {
            if(checkedVal.totalItem?.Drug?.id && !checkedVal.IsSelected) {
                this.checkDrugValidation(checkedVal,checkedVal?.totalItem, checkedVal.index);
            } else this.emitRxSelection.emit(this.selectedItemList);
        }    
    }

    checkDrugValidation(checkedVal,totalItem,ind,from?) {
        if(checkedVal.IsElectronic == 1 ) {
            this.checkPrescPhonenum(checkedVal,totalItem,totalItem?.Prescriber?.mobile,ind,from,totalItem?.Prescription?.PrescNum);
        }
        else if(!totalItem.IsPotencyUnitCodePresent) {
            this.eRxDrugMissingModel = this._modalService.open(DrugMissingFormComponent, { keyboard: false, centered: true,  backdrop: false, windowClass: "large--content max-modal-34" });
                this.eRxDrugMissingModel.componentInstance.drugInfo = totalItem['Drug'];
                this.eRxDrugMissingModel.componentInstance.RxNumber = totalItem['Prescription']['PrescNum'];
                this.eRxDrugMissingModel.componentInstance.closeDrugMissingValues.pipe(takeUntil(this.unsubscribe$)).subscribe(async (resp: any) => { 
                    if(resp) {
                        if(resp == 'cancel') {
                           totalItem.IsPotencyUnitCodePresent = false;
                           checkedVal.IsSelected = false;
                        } 
                        if(from === 'eRxProccess' && (this.rxList?.TransferableRx?.length || this.rxList.NonTransferableRx?.length)) {
                             this.generatingWJCols(this.rxList.TransferableRx.concat((this.rxList.NonTransferableRx?.length) ? this.rxList.NonTransferableRx : []));
                        }
                    } else {
                        totalItem.IsPotencyUnitCodePresent = true;
                    }
                if(this.eRxDrugMissingModel) {
                    this.eRxDrugMissingModel.close();
                    this.eRxDrugMissingModel = null;
                    this.checkValidations(checkedVal,totalItem,ind,from);
                }
                });
        } else{
            if(from === 'eRxProccess' && (this.rxList?.TransferableRx?.length || this.rxList.NonTransferableRx?.length)) {
                    this.generatingWJCols(this.rxList.TransferableRx.concat((this.rxList.NonTransferableRx?.length) ? this.rxList.NonTransferableRx : []));
            }
            this.checkValidations(checkedVal,totalItem,ind,from);
        }
    }

    checkValidations(checkedVal,erxItem,index,from?) {
            if (erxItem?.Prescriber?.mobile) {
                this.checkPrescPhonenum(checkedVal,erxItem,erxItem?.Prescriber?.mobile,index,from,erxItem?.Prescription?.PrescNum);
            } else if (erxItem?.Prescriber?.telephone) {
                this.checkPrescPhonenum(checkedVal,erxItem,erxItem?.Prescriber?.telephone,index,from,erxItem?.Prescription?.PrescNum);
            } else if (erxItem?.Prescriber?.worknumber) {
                this.checkPrescPhonenum(checkedVal,erxItem,erxItem?.Prescriber?.worknumber,index,from,erxItem?.Prescription?.PrescNum);
            } else if (checkedVal?.IsElectronic == 3 && this.eRxModelFG?.value['targetPharmacy'] &&this.eRxModelFG?.value['targetPharmacy']['ServiceLevel'] === false) {
                let msg = "The selected Rx# " + erxItem?.Prescription?.PrescNum + " is informational and cannot be transferred via fax.";
                this._alertServ.error(msg);
                this.selectedItemList.splice(index,1);
                this.emitRxSelection.emit(this.selectedItemList);
                if((this.rxList.TransferableRx?.length || this.rxList.NonTransferableRx?.length)) this.generatingWJCols(this.rxList.TransferableRx.concat((this.rxList.NonTransferableRx?.length) ? this.rxList.NonTransferableRx : []));
                return checkedVal.IsSelected = false;
            }
            else {
            let msg = "Rx# "+ erxItem?.Prescription?.PrescNum +" cannot be transferred because the prescriber("+ (erxItem.Prescriber ? (erxItem.Prescriber?.prescriberlastname + ", " + erxItem.Prescriber?.prescriberfirstname)?.toUpperCase() : null)+") telephone number is missing.";
            this._alertServ.error(msg);
            const ind = from && from === 'eRxProccess' ? index : this.selectedItemList.findIndex((item: any) => { return item.index === index; });
            this.selectedItemList.splice(ind,1);
            this.emitRxSelection.emit(this.selectedItemList);
            if(from === 'eRxProccess' && (this.rxList.TransferableRx?.length || this.rxList.NonTransferableRx?.length)) this.generatingWJCols(this.rxList.TransferableRx.concat((this.rxList.NonTransferableRx?.length) ? this.rxList.NonTransferableRx : []));
            return checkedVal.IsSelected = false;
        } 
    }

    async checkPrescPhonenum(checkedVal,erxItem,phnNum,ind,from?,rxId?) {
        if(phnNum < 10 && checkedVal?.IsElectronic != 1) {
            let msg = "Rx# "+ erxItem?.Prescription?.PrescNum +" is missing a required prescriber phone must be greater than or equals to 10 digits for "+ (erxItem.Prescriber ? (erxItem.Prescriber?.prescriberlastname + ", " + erxItem.Prescriber?.prescriberfirstname).toUpperCase() : null)+".";
            this._alertServ.error(msg);
            const index = from && from === 'eRxProccess' ? ind : this.selectedItemList.findIndex((item: any) => { return item.index === ind; });
            this.selectedItemList.splice(index,1);
            this.emitRxSelection.emit(this.selectedItemList);
            if(from === 'eRxProccess' && (this.rxList.TransferableRx?.length || this.rxList.NonTransferableRx?.length)) this.generatingWJCols(this.rxList.TransferableRx.concat((this.rxList.NonTransferableRx?.length) ? this.rxList.NonTransferableRx : []));
            return checkedVal.IsSelected = false;
        } else if (checkedVal?.IsElectronic == 3 && this.eRxModelFG?.value['targetPharmacy'] && this.eRxModelFG?.value['targetPharmacy']['ServiceLevel'] === false) {
                let msg = "The selected Rx# " + erxItem?.Prescription?.PrescNum + " is informational and cannot be transferred via fax.";
                this._alertServ.error(msg);
                this.selectedItemList.splice(ind,1);
                this.emitRxSelection.emit(this.selectedItemList);
                if((this.rxList?.TransferableRx?.length || this.rxList?.NonTransferableRx?.length)) this.generatingWJCols(this.rxList?.TransferableRx.concat((this.rxList?.NonTransferableRx?.length) ? this.rxList?.NonTransferableRx : []));
                return checkedVal.IsSelected = false;
        } else if(checkedVal?.totalObj?.isTranserable) {
            const RefillorRx = this._commonSer.getSetttingValue("PharmacySettings", "ALLOW_REFILL_TRANS_OUT") === "1" ? true : false;
            this.transfData = erxItem;
             const resp: any =  await this._rxService.getMultipleRxTransferDetails({
               lsttransferRxDetails : [{
                        PrescNum: erxItem.Prescription.PrescNum,
                        PrescRefillId: erxItem.PrescReFill.Id,
                        filter: true
                    }],
                    RefillorRx : this._commonSer.getSetttingValue("PharmacySettings", "ALLOW_REFILL_TRANS_OUT") === "1" ? true : false
             }).toPromise();
             this.notuprxsresponse = resp?.length ? resp[0] : null;

            let reverseRefillList = [], billedPickupList: any = [];
                billedPickupList = this.notuprxsresponse?.Rxtransfer?.reverseRefillList
                ?.filter((item: any) => item.RxBillStatusId === 2 && item?.IsPickedUp)
                .map((item: any) => (item?.PrescNum + "-" + item?.RefillNum)+""+ (this._commonSer.checkIsPartialFill(item) ? "-" + item?.PartialFillNo : ''));

                 reverseRefillList = this.notuprxsresponse?.Rxtransfer?.reverseRefillList
                ?.filter((item: any) => item.RxBillStatusId === 2 && !item?.IsPickedUp)
                .map((item: any) => (item?.PrescNum + "-" + item?.RefillNum)+""+ (this._commonSer.checkIsPartialFill(item) ? "-" + item?.PartialFillNo : ''));
                this.reverseRefillList = reverseRefillList
                let transferRefillList = [];
                transferRefillList = this.notuprxsresponse?.Rxtransfer?.transferRefillList;

                this.transferRefillDifferList = this.notuprxsresponse?.Rxtransfer?.transferRefillList
                ?.filter((item: any) => item.RxBillStatusId === 6)
                .map((item: any) => (item?.PrescNum + "-" + item?.RefillNum) +""+ (this._commonSer.checkIsPartialFill(item) ? "-" + item?.PartialFillNo : ''));

                this.transferRefillUnbilledList = this.notuprxsresponse?.Rxtransfer?.transferRefillList
                ?.filter((item: any) => item.RxBillStatusId === 1)
                .map((item: any) => (item?.PrescNum + "-" + item?.RefillNum) +""+ (this._commonSer.checkIsPartialFill(item) ? "-" + item?.PartialFillNo : ''));   

            if (this.notuprxsresponse  && reverseRefillList?.length && RefillorRx && this.notuprxsresponse?.Rxtransfer?.PendingQtyRem) {
                this.isPickup.messages = null;
                this.isPickup.IsConfirm = false;
                this.isPickup.IsWarn = false;
                this.isPickup.ManualReversal = true;
                this.isPickup.TransferNext = true;
                this.isPickup.IsOk = false;
                this.openWarningMessage(reverseRefillList?.length ? 'medium-sm-modal-3578' : 'medium-sm-modal-3478',  (reverseRefillList?.length ? 'Refills' : 'Refill') + " Not Picked Up");
            }  else if (this.notuprxsresponse && !this.notuprxsresponse?.Rxtransfer?.IsPickedUp && this.notuprxsresponse?.Rxtransfer?.RxStatusId === 2 && !RefillorRx && this.notuprxsresponse?.Rxtransfer?.PendingQtyRem) {
                // Billed and Un pick up and refill transfer out
                    this.isPickup.messages = "<div>The refill for <strong> Rx#: " + this.transfData?.Prescription?.PrescNum + "-" + this.transfData?.PrescReFill?.ReFillNum  +  "</strong> was <strong>billed </strong> on <strong>" + moment(this.notuprxsresponse?.Rxtransfer?.FillDtTm).format(MsgConfig.DATE_FORMAT) + "</strong> but <strong>not picked up </strong> by the patient.</div><div>To transfer the unpicked refill, please reverse it first and then transfer.</div>";
                    this.isPickup.ManualReversal = true;
                    this.isPickup.TransferNext = true;
                    this.isPickup.IsOk = false;
                      this.openWarningMessage('medium-sm-modal-3478', "Refill Not Picked Up");
            }   else if (this.notuprxsresponse && !this.notuprxsresponse?.Rxtransfer?.IsPickedUp && [1,3].includes(this.notuprxsresponse?.Rxtransfer?.RxStatusId) && !RefillorRx && this.notuprxsresponse?.Rxtransfer?.PendingQtyRem) {
                // Unbilled  and Un pick up and refill transfer out
                var messageHtml = "The refill for <strong> Rx#: "+ this.transfData?.Prescription?.PrescNum + "-" + this.transfData?.PrescReFill?.ReFillNum + "</strong> filled on <strong>"+moment(this.notuprxsresponse?.Rxtransfer?.FillDtTm).format(MsgConfig.DATE_FORMAT)+"</strong> was <strong> not picked up by the patient.</strong><ul><li><strong>Select Yes</strong> – To Transfer the <strong>existing unpicked refill</strong></li><li><strong>Select No</strong> – To Create and transfer a<strong> new refill</strong></li></ul>";
               this.isPickup.messages = messageHtml;
                this.isPickup.IsConfirm = true;
                this.isPickup.IsWarn = false;
                this.isPickup.ManualReversal = false;
                this.isPickup.TransferNext = false;
                this.isPickup.IsOk = false;
                    this.openWarningMessage("max-modal-3575", "Refill Not Picked Up");
            } else if(this.notuprxsresponse  && transferRefillList?.length > 1 && RefillorRx) {
                const values = new Set(this.notuprxsresponse?.Rxtransfer?.transferRefillList.map(x => x.RxBillStatusId));
                this.statusName = "";
                if (values.has(1) && values.has(6)) {
                    this.statusName = "unbilled, deferred";
                } else if (values.has(1)) {
                    this.statusName = "unbilled";
                } else if (values.has(6)) {
                    this.statusName = "deferred";
                }
                this.isPickup.messages = null;
                this.isPickup.IsOk = true;
                this.isPickup.IsConfirm = false;
                this.isPickup.IsWarn = false;
                this.isPickup.ManualReversal = false;
                this.isPickup.TransferNext = false;
                this.openWarningMessage("max-modal-3775", "Warning!!");
                this.emitRxSelection.emit(this.selectedItemList);
            }
            else {
                if(this.notuprxsresponse && !this.notuprxsresponse?.Rxtransfer?.IsPickedUp &&  [1,3,6].includes(this.notuprxsresponse?.Rxtransfer?.RxStatusId) && !RefillorRx && ((this.notuprxsresponse?.Rxtransfer?.RxStatusId == 6) ? this.notuprxsresponse?.Rxtransfer?.PendingQtyRem : !this.notuprxsresponse?.Rxtransfer?.PendingQtyRem)) {
                     const index = this.selectedItemList?.findIndex((item: any) => item?.PrescReFill?.Id === this.transfData?.PrescReFill?.Id);
                    this.selectedItemList[index]['isCurrentRefillTransfer'] = true;
                }
                this.emitRxSelection.emit(this.selectedItemList);
                if(from && (this.rxList.TransferableRx?.length || this.rxList.NonTransferableRx?.length))
                    this.generatingWJCols(this.rxList.TransferableRx.concat((this.rxList.NonTransferableRx?.length) ? this.rxList.NonTransferableRx : []));
            }
        } else {
            this.emitRxSelection.emit(this.selectedItemList);
            if(from && (this.rxList.TransferableRx?.length || this.rxList.NonTransferableRx?.length))
                this.generatingWJCols(this.rxList.TransferableRx.concat((this.rxList.NonTransferableRx?.length) ? this.rxList.NonTransferableRx : []));
        }
        
    }

    openWarningMessage(IsPopWidthClass: string = 'medium-sm-modal-337', title: string = "") {
          this.PopupHeader  = title;
              this.modalRef = this._modalService.open(this.ConfirmMesgBeforeTransferOut, { centered: true, backdrop: false, windowClass: `${IsPopWidthClass} large--content` });
    }

    IsPickOrUnPick(IsClick) {
        if (!IsClick)
            if ([6, 1].includes(this.notuprxsresponse?.Rxtransfer?.RxStatusId) && this.notuprxsresponse?.Rxtransfer?.PendingQtyRem && !this.notuprxsresponse?.Rxtransfer?.IsPickedUp)
                this.closePopUpReset(IsClick);
            else {
                this.closePopUp();
            }
        else {
            IsClick = (this.notuprxsresponse?.Rxtransfer?.RxStatusId == 2 && !this.notuprxsresponse?.Rxtransfer?.IsPickedUp) ? false : (
                (this.notuprxsresponse?.Rxtransfer?.RxStatusId == 4) ? false : IsClick
            );
            this.closePopUpReset(IsClick);
        }
    }
    
    closePopUpReset(IsClick) {
            if (this.modalRef) {
                this.modalRef.close();
                this.modalRef = null;
            }
            const index = this.selectedItemList?.findIndex((item: any) => item?.PrescReFill?.Id === this.transfData?.PrescReFill?.Id);
            this.selectedItemList[index]['isCurrentRefillTransfer'] = IsClick;

            this.emitRxSelection.emit(this.selectedItemList);
            this.isPickup.IsConfirm = false;
    }
    
    closePopUp() {
         this.isPickup.IsConfirm = false;
         this.isPickup.IsWarn = false;
         this.isPickup.messages = "";
        if( this.modalRef) {
             this.modalRef.close();
              this.modalRef = null;
        }
        const index = this.rxList?.TransferableRx.findIndex((item: any) => { return  item?.erxViewModel?.PrescReFill?.Id === this.transfData?.PrescReFill?.Id });
        const index1 = this.rxList?.NonTransferableRx.findIndex((item: any) => { return  item?.erxViewModel?.PrescReFill?.Id === this.transfData?.PrescReFill?.Id });
        if (index !== -1) {
            this.rxList.TransferableRx[index]['IsSelected'] = false;
            if (this.rxList?.TransferableRx?.length || this.rxList.NonTransferableRx?.length) {
                const index2 = this.selectedItemList.findIndex((eRx: any) => { return eRx?.PrescReFill?.Id === this.transfData?.PrescReFill?.Id });
                if(index2 !== -1) {
                    this.selectedItemList.splice(index2,1);
                    this.emitRxSelection.emit(this.selectedItemList);
                    if((this.rxList.TransferableRx?.length || this.rxList.NonTransferableRx?.length)) this.generatingWJCols(this.rxList.TransferableRx.concat((this.rxList.NonTransferableRx?.length) ? this.rxList.NonTransferableRx : []));
                    return this.rxList.TransferableRx[index].IsSelected = false;
                }
            }
        } else  if (index1 !== -1 && this.rxList.NonTransferableRx?.length) {
            this.rxList.NonTransferableRx[index]['IsSelected'] = false;
            if (this.rxList?.NonTransferableRx?.length || this.rxList.NonTransferableRx?.length) {
                const index2 = this.selectedItemList.findIndex((eRx: any) => { return eRx?.PrescReFill?.Id === this.transfData?.PrescReFill?.Id });
                if(index2 !== -1) {
                    this.selectedItemList.splice(index2,1);
                    this.emitRxSelection.emit(this.selectedItemList);
                    if((this.rxList.NonTransferableRx?.length || this.rxList.NonTransferableRx?.length)) this.generatingWJCols(this.rxList.TransferableRx.concat((this.rxList.NonTransferableRx?.length) ? this.rxList.NonTransferableRx : []));
                    return this.rxList.NonTransferableRx[index].IsSelected = false;
                }
            }
        }
    }
  getDetails() {
    this._eRxService.getAwaitErx(this.currentDetails.ID, this.currentDetails.Version, this.currentDetails.ErxOperationId, this.currentDetails?.PatientId).pipe(takeUntil(this.unsubscribe$)).subscribe(resp => {
        if (resp) {
            this.awaitInfo = resp;
            this.IseRxTRxREQ = true;
        }
    });
 }

 showFullScreen() {
    this.showFullscreenMode.emit(this.selectedItemList);
 }

 closeRxPopup() {
    this._storageService.removedSessionStorage("FullScreen");
      if(this.modelRef) {
        this.modelRef.close();
        this.modelRef = null;
      }
 }

  itemFormatter = (panel, r, c, cell) => {
          const row = panel.rows[r];
          if (row && row.dataItem) {
              cell.style.background = "";
               if (panel.cellType === wjcGrid.CellType.Cell && !(panel.columns[c].binding) && row?.dataItem?.IsSpecificNDCAMatchedRecord) {
                             cell.style.borderLeft = "5px solid #997BB7";
               }
              else if (panel.cellType === wjcGrid.CellType.Cell && panel.columns[c].binding === "Rx#") {
                  const colors = this._colorCodeRx.showRxColorCodeAndHoverOver(row.dataItem["totalItem"], "RxObject", "Rx");
                  if (colors && colors.bg && colors.color) {
                      cell.style.background = colors.bg;
                      cell.style.color = colors.color;
                  } else {
                      cell.style.background = "#FFF";
                      cell.style.color = "#000";
                  }
                  cell.style.fontWeight = "bold";
                  cell.style.paddingLeft = "1rem";
              }  else if (panel.cellType === wjcGrid.CellType.Cell && panel.columns[c].binding === "Status") {
                              const colors = this._colorCode.showRxStatusColorRefactoring(row.dataItem);
                              if(colors && colors.bg && colors.color) {
                                  cell.style.background = colors.bg;
                                  cell.style.color = colors.color;
                              } else {
                                  cell.style.background = "#FFF";
                                  cell.style.color = "#000";
                              }
                              cell.style.fontWeight = "bold";
                              cell.style.paddingLeft = "1rem";
            }  else if (panel.cellType === wjcGrid.CellType.Cell && panel.columns[c].binding === "Drug Name") {
                  const colors = this._colorCode.showDrugColorRefactoring(row.dataItem);
                  if(colors && colors.bg && colors.color) {
                      cell.style.background = colors.bg;
                      cell.style.color = colors.color;
                  } else {
                      cell.style.background = "#FFF";
                      cell.style.color = "#000";
                  }
                  cell.style.fontWeight = this.payload?.erxOperationIdList?.length ? "normal" : "bold";
                  cell.style.paddingLeft = "1rem";
              }    else {
                  cell.style.backgroundColor = "#FFF";
                  cell.style.color = "#000";
                  cell.style.fontWeight = "normal";
                  cell.style.textAlign = "initial";
                  cell.style.borderLeft = "none"
              }
          }
      };

    getTransferMode(value, item) {
        if(item.totalItem?.Drug?.id && item.IsSelected && value?.value?.id !=1) {
            this.checkDrugValidation(item,item?.totalItem, item.index);
        }
        if(this.selectedItemList?.length) {
            const ind = this.selectedItemList.findIndex((eRx: any) => { return eRx?.index === item.index });
            if(ind !== -1) {
                this.selectedItemList[ind].checkTransfer = value?.value?.id;
                this.selectedItemList[ind].IsElectronic = value?.value?.id;
            }
        }
       return item.IsElectronic = value?.value?.id;   
    }
  
    init(flex: wjcGrid.FlexGrid) {
        flex.columnHeaders.rows[0].wordWrap = true;
            flex.autoSizeRow(0, true);
    }

    editPrescriber(data,type) {
        if (type === "EditPrescriber" && data["totalItem"]["Prescriber"]["prescriberid"]) {
            this._patPreDrugService._patPreDrugModal$.next("prescriber");
            const modalRef = this._patPreDrugService.modalInstanceRef;
            modalRef.componentInstance.prescriberID = +data["totalItem"]["Prescriber"]["prescriberid"];
            modalRef.componentInstance.ClosePrescriberModal.pipe(takeUntil(this.unsubscribe$)).subscribe(resp => {
                modalRef.close();
                if(resp && resp?.Type === "Update") {
                    this.getRxsForTransferInReq(this.IsTransferType ? null : this.eRxModelFG?.value?.patientInfo ? this.eRxModelFG?.value?.patientInfo : '');
                }
            });
        }
    }
}
